module.exports = __webpack_public_path__ + "464325746fb6f97b95546abbf7e9b430.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/purchase-history/sms-purchase-history.html
// module id = 1673
// module chunks = 0